<template>
  <div class="league">
    <div class="flex flex-row">
      <div>
        <div class="flex flex-row flex-between flex-middle">
          <div class="flex flex-middle">
            <div v-if="data.leagueIco" class="league-icoWrap">
              <img :src="data.leagueIco" class="league-ico" />
            </div>
            <div class="league-name pointer">
              {{ data.leagueName }}
            </div>
          </div>
          <div class="league-add pointer" @click.stop="joinAlliance(data)">
            <i class="el-icon-circle-plus"></i>
            <span>加入联盟</span>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="league-brief">
          {{ data.leagueBrief }}
        </div>
        <div class="flex flex-row">
          <div class="member flex flex-row flex-between">
            <div class="flex flex-row flex-middle">
              <img
                :src="$oss('alliance/icon-member.png')"
                class="member-icon"
              />
              <div>联盟成员</div>
            </div>
            <div class="member-right flex flex-middle">
              <div class="member-num">{{ data.memberNum }}</div>
            </div>
          </div>
          <div class="activity flex flex-row">
            <div class="flex flex-row flex-middle">
              <img
                :src="$oss('alliance/icon-activity.png')"
                class="activity-icon"
              />
              <div class="activity-label">最新活动</div>
            </div>
            <div class="flex-1 flex flex-middle">
              <div class="activity-name">
                {{ data.newActivityName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showImgIndex: 0,
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  methods: {
    mouseoverImg(index) {
      this.showImgIndex = index;
    },
    joinAlliance() {
      if (!this.token) {
        this.$store.dispatch("login");
        return;
      }
      this.$router.push({
        name: "joinAlliance",
        query: {
          allianceId: this.data.leagueId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
@mixin imgCommon() {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.member,
.activity {
  width: 400px;
  border-radius: 8px;
  padding: 10px;
  color: white;
  font-weight: 400;
  &-icon {
    width: 48px;
    height: 48px;
  }
}
.member {
  background: linear-gradient(90deg, #1082bd 0%, #005ca7 100%);
  margin-right: 20px;
  &-right {
    color: white;
    text-align: center;
  }
  &-num {
    font-size: 18px;
    font-weight: bold;
  }
}
.activity {
  background: linear-gradient(90deg, #ff9531 0%, #fb553f 100%);
  color: white;
  &-name {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  &-label {
    font-weight: bold;
    margin-right: 16px;
  }
}
.league {
  background: white;
  margin-bottom: 20px;
  padding: 16px;
  &-ico {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
  ::v-deep .el-divider--horizontal {
    margin: 10px 0;
  }
  &-icoWrap {
    margin-right: 15px;
  }
  &-name {
    font-size: 16px;
    font-weight: bold;
  }
  &-brief {
    color: #777777;
    margin-bottom: 25px;
  }
  &-add {
    color: $theme-color;
    i {
      margin-right: 5px;
      font-size: 18px;
      position: relative;
      top: 2px;
    }
  }
}
</style>
